import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CvNavigation from '../../../components/CvNavigation';
import CvPageLayout from '../../../components/CvPageLayout';
import DeleteModal from '../../../components/DeleteModal';
import EducationEmploymentList from '../../../components/EducationEmploymentList';
import EducationEmploymentAddForm from '../../../components/EducationEmploymentAddForm';

import {
  deleteEducation,
  fetchEducation,
} from '../../../actions/educationActions';
import { DELETE_EDUCATION_RESET } from '../../../constants/educationConstants';

function CvGeneratorEducation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const educationState = useSelector((state) => state.educationList) || {};
  const { educations } = educationState;
  const { error: errorDelete, success: successDelete } = useSelector(
    (state) => state.educationDelete
  );

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [educationToDelete, setEducationToDelete] = useState(null);

  useEffect(() => {
    if (successDelete) {
      setShowDeleteModal(false);
      dispatch({ type: DELETE_EDUCATION_RESET });
      dispatch(fetchEducation());
    }
  }, [dispatch, successDelete]);

  useEffect(() => {
    dispatch(fetchEducation());
  }, [dispatch]);

  const handleShowDeleteModal = (id) => {
    setEducationToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (educationToDelete) {
      dispatch(deleteEducation(educationToDelete));
    }
  };

  const handleEdit = (edu, type) => {
    // important: pass currentlyStudying and description so forms/description pages receive them
    const statePayload = {
      id: edu.id,
      school_name: edu.school_name,
      city: edu.city,
      start_date: edu.start_date?.slice(0, 7),
      end_date: edu.end_date?.slice(0, 7),
      // derive boolean from presence of end_date (same approach used in experience)
      currentlyStudying: !edu.end_date,
      description: edu.description || [],
    };

    if (type === 'description') {
      navigate('/cv-career/cv-generator/section/education/description', {
        state: statePayload,
      });
    } else {
      navigate('/cv-career/cv-generator/section/education/form', {
        state: statePayload,
      });
    }
  };

  const capitalize = (str) =>
    !str ? '' : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}.${year}`;
  };

  return (
    <CvPageLayout currentStep="Edukacja">
      <Row className="justify-content-md-center mt-2">
        <Col>
          {educations && educations.length > 0 ? (
            educations.map((edu, index) => (
              <EducationEmploymentList
                key={edu.id}
                id={edu.id}
                number={index + 1}
                name={capitalize(edu.school_name)}
                city={capitalize(edu.city)}
                start_date={formatDate(edu.start_date)}
                end_date={edu.end_date ? formatDate(edu.end_date) : 'Obecnie'}
                tasks={edu.description || []}
                onDelete={() => handleShowDeleteModal(edu.id)}
                onEdit={(type) => handleEdit(edu, type)}
              />
            ))
          ) : (
            <div className="text-secondary fst-italic mt-3">
              Brak infomacji o wykształceniu
            </div>
          )}
        </Col>
      </Row>

      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        error={errorDelete}
      />

      <Row className="justify-content-md-center mt-3">
        <Col>
          <EducationEmploymentAddForm
            name="Dodaj wykształcenie"
            nextlink="/cv-career/cv-generator/section/education/form"
          />
        </Col>
      </Row>

      <CvNavigation 
        backlink="/cv-career/cv-generator/section/experience"
        nextlink="/cv-career/cv-generator/section/languages"
      />

    </CvPageLayout>
  );

}
export default CvGeneratorEducation;
